import http from "../http";
import api from "../../config/api";

const forms = {
  getForm: (id: string): Promise<any> => {
    return http.get(`${api.getForm}/${id}`);
  },
};

export default forms;
